import { render, staticRenderFns } from "./FlexEmployeeSideNav.vue?vue&type=template&id=6d606ce9&scoped=true&"
import script from "./FlexEmployeeSideNav.vue?vue&type=script&lang=js&"
export * from "./FlexEmployeeSideNav.vue?vue&type=script&lang=js&"
import style0 from "./FlexEmployeeSideNav.vue?vue&type=style&index=0&id=6d606ce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d606ce9",
  null
  
)

export default component.exports